import { NavLink } from 'react-router-dom'
import React from 'react'
import moment from 'moment'
import gold from '../../static/medal/gold.png'
import silver from '../../static/medal/silver.png'
import bronze from '../../static/medal/bronze.png'

export const trophyBookMenu = (t: any) => [
  {
    key: 'hunter-book',
    label: t('h140'),
    children: [
      {
        key: 'information',
        label: (
          <NavLink state={{ breadcrumbs: t('m7') }} to={`/trophy-book/information`}>
            {t('m22')}
          </NavLink>
        ),
      },
      {
        key: 'hunter-book',
        label: (
          <NavLink state={{ breadcrumbs: t('m7') }} to={`/trophy-book/hunter-book`}>
            {t('m7')}
          </NavLink>
        ),
      },
    ],
  },
  {
    key: 'hunter-rating',
    label: (
      <NavLink state={{ breadcrumbs: t('m7') }} to={`/trophy-book/hunter-rating`}>
        {t('h141')}
      </NavLink>
    ),
  },
  {
    key: 'hunting-grounds-rating',
    label: (
      <NavLink state={{ breadcrumbs: t('m7') }} to={`/trophy-book/hunting-grounds-rating`}>
        {t('h142')}
      </NavLink>
    ),
  },
]

const dateFormat = 'DD.MM.YYYY'

export const columnsHunterBook = (t: any, sortOrder: any, paginataion: any) => [
  {
    title: '№',
    dataIndex: 'index',
    key: 'index',
    width: 50,
    align: 'center',
    render: (_: any, e: any, index: number) => {
      const currentPage = Number(paginataion ?? 1)
      const itemsPerPage = 50
      const startIndex = (currentPage - 1) * itemsPerPage
      return startIndex + index + 1
    },
  },
  {
    title: t('h143'),
    dataIndex: 'hunter',
    key: 'hunter',
    width: 190,
    sorter: true,
    ellipsis: true,
    sortOrder: sortOrder?.field === 'hunter' ? sortOrder.order : undefined,
    render: (_: any, { hunter }: { hunter: { full_name: string } }) => hunter?.full_name || '',
  },
  {
    title: t('h117'),
    dataIndex: 'hunting_farm',
    key: 'hunting_farm',
    width: 190,
    sorter: true,
    sortOrder: sortOrder?.field === 'hunting_farm' ? sortOrder.order : undefined,
    render: (_: any, { hunting_farm }: { hunting_farm: { title: string } }) => hunting_farm?.title || '',
  },
  {
    title: t('h106'),
    dataIndex: 'date',
    key: 'date',
    align: 'center',
    width: 100,
    sorter: true,
    sortOrder: sortOrder?.field === 'date' ? sortOrder.order : undefined,
    render: (_: any, { date }: { date: string }) => moment(date).format(dateFormat),
  },
  {
    title: t('h116'),
    dataIndex: 'trophy_type',
    key: 'trophy_type',
    align: 'center',
    width: 110,
    sorter: true,
    sortOrder: sortOrder?.field === 'trophy_type' ? sortOrder.order : undefined,
    render: (_: any, { trophy_type }: { trophy_type: { name: string } }) => trophy_type?.name || '',
  },
  {
    title: t('h118'),
    dataIndex: 'point',
    key: 'point',
    align: 'center',
    width: 70,
    sorter: true,
    sortOrder: sortOrder?.field === 'point' ? sortOrder.order : undefined,
  },
  {
    title: t('h121'),
    dataIndex: 'medal',
    key: 'medal',
    align: 'center',
    width: 75,
    sorter: true,
    sortOrder: sortOrder?.field === 'medal' ? sortOrder.order : undefined,
    render: (_: any, { medal }: { medal: number }) => {
      switch (medal) {
        case 3:
          return <img src={gold} alt="gold" />
        case 2:
          return <img src={silver} alt="silver" />
        case 1:
          return <img src={bronze} alt="bronze" />
      }
    },
  },
  // {
  //   title: '',
  //   key: 'status',
  //   dataIndex: 'status',
  //   render: () => <EyeOutlined style={{ fontSize: 15, cursor: 'pointer' }} />,
  // },
]
export const columnsHunterRating: any = (t: any, sortOrder: any, paginataion: any) => [
  {
    title: '№',
    dataIndex: 'index',
    key: 'index',
    width: '50px',
    align: 'center',
    render: (_: any, e: any, index: number) => {
      const currentPage = Number(paginataion ?? 1)
      const itemsPerPage = 50
      const startIndex = (currentPage - 1) * itemsPerPage
      return startIndex + index + 1
    },
  },
  {
    title: t('h143'),
    dataIndex: 'hunter',
    key: 'hunter',
    width: 150,
    sorter: true,
    ellipsis: true,
    sortOrder: sortOrder?.field === 'hunter' ? sortOrder.order : undefined,
    render: (
      _: any,
      { last_name, first_name, middle_name }: { last_name: string; first_name: string; middle_name: string },
    ) => `${last_name || ''} ${first_name || ''}  ${(middle_name && '.' + middle_name) || ''}`,
  },
  {
    title: t('h146'),
    dataIndex: 'result',
    key: 'result',
    align: 'center',
    width: 190,
    sorter: true,
    sortOrder: sortOrder?.field === 'result' ? sortOrder.order : undefined,
  },
  {
    title: t('h147'),
    dataIndex: 'count',
    key: 'count',
    align: 'center',
    width: 190,
    sorter: true,
    sortOrder: sortOrder?.field === 'count' ? sortOrder.order : undefined,
  },
  // {
  //   title: '',
  //   key: 'status',
  //   dataIndex: 'status',
  //   render: () => <EyeOutlined style={{ fontSize: 15, cursor: 'pointer' }} />,
  // },
]
export const columnsHunterGroupRating: any = (t: any, sortOrder: any, paginataion: any) => [
  {
    title: '№',
    dataIndex: 'index',
    key: 'index',
    width: 'auto',
    align: 'center',
    render: (_: any, e: any, index: number) => {
      const currentPage = Number(paginataion ?? 1)
      const itemsPerPage = 50
      const startIndex = (currentPage - 1) * itemsPerPage
      return startIndex + index + 1
    },
  },
  {
    title: t('h117'),
    dataIndex: 'farm_title',
    key: 'farm_title',
    width: 350,
    sorter: true,
    sortOrder: sortOrder?.field === 'farm_title' ? sortOrder.order : undefined,
  },
  {
    title: t('h146'),
    dataIndex: 'result',
    key: 'result',
    align: 'center',
    width: 190,
    sorter: true,
    sortOrder: sortOrder?.field === 'result' ? sortOrder.order : undefined,
  },
  {
    title: t('h147'),
    dataIndex: 'count',
    key: 'count',
    align: 'center',
    width: 190,
    sorter: true,
    sortOrder: sortOrder?.field === 'count' ? sortOrder.order : undefined,
  },
  // {
  //   title: '',
  //   key: 'status',
  //   dataIndex: 'status',
  //   render: () => <EyeOutlined style={{ fontSize: 15, cursor: 'pointer' }} />,
  // },
]
